module.exports = __webpack_public_path__ + "img/menu-send.9943d052.png";